module.exports = __webpack_public_path__ + "static/media/2-en.1ce639f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/2-en.wav
// module id = pfV3
// module chunks = 1